import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useShallow } from "zustand/react/shallow";

import { t } from "@/i18n-js/instance";

import { DOM_IDS } from "./Layout/defaults";
import { useCircleAIShellStore } from "./store/circleAIShellStore";

export const DockToggleButton = () => {
  const { toggleDockMode, dockMode } = useCircleAIShellStore(
    useShallow(s => ({
      toggleDockMode: s.toggleDockMode,
      dockMode: s.dockMode,
    })),
  );

  const label =
    dockMode === "expanded"
      ? t("circle_ai_shell.collapse_sidebar")
      : t("circle_ai_shell.expand_sidebar");

  return (
    <Tooltip content={label} side="right">
      <IconButton
        data-testid="circle-ai-shell-dock-toggle"
        icon="layout-left"
        variant="ghost"
        onClick={toggleDockMode}
        aria-label={label}
        aria-expanded={dockMode === "expanded"}
        aria-controls={DOM_IDS.dockBody}
      />
    </Tooltip>
  );
};

DockToggleButton.displayName = "CircleAIAppShell.DockToggleButton";
